<div class="flex">
  <input #inputAviso value={{numAviso}} type="number" min=1 max=60 [ngClass]="[formularioValidacionesService.isAvisoInvalido(indexAviso) ? 'errorInput':'', formularioEnvioService.disableRecordatorio ? 'bg-transparent':'']" [readonly]="formularioEnvioService.disableRecordatorio" (keyup)="updateAviso(inputAviso.value)" (mouseup)="updateAviso(inputAviso.value)">
  <span class="eliminar" (click)="eliminarAviso()">
    <svg class="icon-close">
      <use xlink:href="#hs-bin"></use>
    </svg>
  </span>
</div>
